// extracted by mini-css-extract-plugin
export default {"container":"body_container__1JOdj","inherit":"body_inherit__2EBdE"};